<template>
  <v-card flat rounded class="my-2">
    <v-card-text>
      <h2 class="secondary--text mb-4">Review & Submit</h2>
      <p class="mb-4">Please review the contractor details before submitting.</p>

      <v-card outlined class="mb-4">
        <v-card-title class="subtitle-1">Personal Details</v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" md="6">
              <div class="caption grey--text">Name</div>
              <div>
                {{ formData.contractorDetails.title }}
                {{ formData.contractorDetails.forename }}
                {{ formData.contractorDetails.middlename }}
                {{ formData.contractorDetails.surname }}
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="caption grey--text">Company</div>
              <div>{{ formData.contractorDetails.companyName || "N/A" }}</div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="caption grey--text">Email</div>
              <div>{{ formData.contractorDetails.email }}</div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="caption grey--text">Mobile Phone</div>
              <div>{{ formData.contractorDetails.mobilePhone }}</div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="caption grey--text">Commission Fee</div>
              <div>{{ formData.contractorDetails.commissionFee }}%</div>
            </v-col>
            <v-col cols="12" v-if="formData.contractorDetails.additionalInfo">
              <div class="caption grey--text">Additional Information</div>
              <div>{{ formData.contractorDetails.additionalInfo }}</div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card outlined class="mb-4">
        <v-card-title class="subtitle-1">Address</v-card-title>
        <v-card-text>
          <div>
            <span v-if="formData.address.flatOrRoomNumber">
              Flat {{ formData.address.flatOrRoomNumber }},
            </span>
            <span v-if="formData.address.addressNumber">
              {{ formData.address.addressNumber }}
            </span>
            {{ formData.address.address1 }}
          </div>
          <div v-if="formData.address.address2">{{ formData.address.address2 }}</div>
          <div v-if="formData.address.address3">{{ formData.address.address3 }}</div>
          <div v-if="formData.address.address4">{{ formData.address.address4 }}</div>
          <div>{{ formData.address.postcode }}</div>
        </v-card-text>
      </v-card>

      <v-card outlined>
        <v-card-title class="subtitle-1">Bank Details</v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" md="6">
              <div class="caption grey--text">Account Name</div>
              <div>{{ formData.bankDetails.accountName }}</div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="caption grey--text">Account Number</div>
              <div>{{ formatAccountNumber(formData.bankDetails.accountNumber) }}</div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="caption grey--text">Sort Code</div>
              <div>{{ formData.bankDetails.sortCode }}</div>
            </v-col>
            <v-col cols="12" md="6" v-if="formData.bankDetails.legacyBacsReference">
              <div class="caption grey--text">BACS Reference</div>
              <div>{{ formData.bankDetails.legacyBacsReference }}</div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-card-text>

    <v-card-actions>
      <v-btn text @click="$emit('back')">
        Back
      </v-btn>
      <v-spacer />
      <v-btn
        color="primary"
        :loading="loading"
        @click="$emit('submit')"
      >
        Submit
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "ContractorReviewStep",
  props: {
    formData: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formatAccountNumber(accountNumber) {
      return accountNumber ? "****" + accountNumber.slice(-4) : "";
    }
  }
};
</script>